import { Buffer } from 'buffer'
import { store } from '../config/redux'

const aesjs = require('aes-js')
const base64js = require('base64-js')

const encrypt = {
    encrypt: text => {
        const state = store.getState()
        const SECRET_KEY = state.configuration.getIn(['7NOW_WEB_AUTH_KEY'])

        const ivBytes = [21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36]
        let textBytes = aesjs.utils.utf8.toBytes(text)
        const myBuffer = []
        // eslint-disable-next-line
        const keyBuffer = new Buffer(new Buffer(SECRET_KEY).toString('base64'), 'utf8').toString()
        for (let i = 0; i < keyBuffer.length; i++) {
            myBuffer.push(keyBuffer.charCodeAt(i))
        }
        const aesCbc = new aesjs.ModeOfOperation.cbc(myBuffer, ivBytes)
        textBytes = aesjs.padding.pkcs7.pad(textBytes)
        const encryptedBytes = aesCbc.encrypt(textBytes)
        const finalEncryptedBytes = new Uint8Array(ivBytes.length + encryptedBytes.length)
        finalEncryptedBytes.set(ivBytes)
        finalEncryptedBytes.set(encryptedBytes, ivBytes.length)
        return base64js.fromByteArray(finalEncryptedBytes)
    },
}

export default encrypt
